import script from "./MaintenanceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaintenanceModal.vue?vue&type=script&setup=true&lang=ts"

import "./MaintenanceModal.vue?vue&type=style&index=0&id=35348b7f&lang=css"

const __exports__ = script;

export default __exports__